import { Container } from '@hub/container'
import React from 'react'
import {
  As,
  HubStyleObject,
  forwardRef,
  StandardSizes,
  HubResponsiveArray,
} from '@hub/design-system-base'

interface CoreContainerProps {
  sx?: HubStyleObject
  as?: As
  fadeOutOverflow?: React.ComponentProps<typeof Container>['fadeOutOverflow']
  gutter?: HubResponsiveArray<string>
  maxWidth?: StandardSizes
  isMobileFullWidth?: boolean
}

export const CoreContainer = forwardRef<CoreContainerProps, typeof Container>(
  (
    { sx, as, children, fadeOutOverflow, gutter, maxWidth, isMobileFullWidth },
    _ref
  ) => (
    <Container
      sx={{ ...sx, maxWidth: maxWidth || 'size-max-fixed' }}
      as={as}
      gutter={
        gutter ||
        (isMobileFullWidth
          ? ['spacing-none', 'spacing-lg', 'spacing-2xl']
          : ['spacing-lg', 'spacing-lg', 'spacing-2xl'])
      }
      fadeOutOverflow={fadeOutOverflow}
    >
      {children}
    </Container>
  )
)

export { ContainerContext as CoreContainerContext } from '@hub/container'
